import React from 'react';
import { useSelector } from 'react-redux';

// Components

import IdahoFooter from '@common-components/footers/IdahoFooter';
import MinnesotaFooter from '@common-components/footers/MinnesotaFooter';
import NevadaFooter from '@common-components/footers/NevadaFooter';
import New_JerseyFooter from '@common-components/footers/New_JerseyFooter';
import New_MexicoFooter from '@common-components/footers/New_MexicoFooter';
import OregonFooter from '@common-components/footers/OregonFooter';
import PennsylvaniaFooter from '@common-components/footers/PennsylvaniaFooter';
import GeorgiaFooter from '@common-components/footers/GeorgiaFooter';
import VirginiaFooter from '@common-components/footers/VirginiaFooter';
import IllinoisFooter from '@common-components/footers/IIllinoisFooter';
import GetinsuredFooter from '@common-components/footers/GetinsuredFooter';

// Constants

import { configs } from '@constants/configs/configs';

const FooterContainer = () => {
    const environment = useSelector(state => state.common.environment);

    if (!environment) {
        return null;
    }

    const { profile, stateCode } = environment;
    const footerProfileKey = profile ?? stateCode;

    switch (true) {
        case footerProfileKey === configs.states.IDAHO:
            return <IdahoFooter {...{ environment }} />;

        case footerProfileKey === configs.states.MINNESOTA:
            return <MinnesotaFooter {...{ environment }} />;

        case footerProfileKey === configs.states.NEVADA:
            return <NevadaFooter {...{ environment }} />;

        case footerProfileKey === configs.states.NEW_JERSEY:
            return <New_JerseyFooter {...{ environment }} />;

        case footerProfileKey === configs.states.NEW_MEXICO:
            return <New_MexicoFooter {...{ environment }} />;

        case footerProfileKey === configs.states.OREGON:
            return <OregonFooter {...{ environment }} />;

        case footerProfileKey === configs.states.PENNSYLVANIA:
            return <PennsylvaniaFooter {...{ environment }} />;

        case footerProfileKey === configs.states.GEORGIA:
            return <GeorgiaFooter {...{ environment }} />;

        case footerProfileKey === configs.states.VIRGINIA:
            return <VirginiaFooter {...{ environment }} />;

        case footerProfileKey === configs.states.ILLINOIS:
            return <IllinoisFooter {...{ environment }} />;

        case footerProfileKey === configs.states.GETINSURED:
            return <GetinsuredFooter {...{ environment }} />;

        default:
            return null;
    }
};

export default FooterContainer;
